module.exports = __webpack_public_path__ + "static/media/icons-kid-babies.caa4e0c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icons-kid-babies.svg
// module id = 783
// module chunks = 0